import mentoriaApi from "../../../services/axiosTokenMiddleware";

const mentoriaFinancieraURL = process.env.REACT_APP_MENTORIA_FINANCIERA_URL || '';
const mentoriaFinancieraApiKey = process.env.REACT_APP_MENTORIA_FINANCIERA_API_KEY || '';

export const obtenerParametros = async () => {
	const response = await mentoriaApi.get(
		`${mentoriaFinancieraURL}financial/get-params`,{
			headers: {
				ApiKey: mentoriaFinancieraApiKey,
				'Content-Type': 'application/json',
			},
		});
	return response.data;
};
